import { jsxs as l, jsx as C } from "react/jsx-runtime";
const d = ({
  size: t = 780,
  testId: i = "unexpected-error-illustration"
}) => /* @__PURE__ */ l(
  "svg",
  {
    "data-testid": i,
    width: typeof t == "number" ? t : t.width,
    height: "auto",
    viewBox: "0 0 780 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_32822_58544)", children: [
        /* @__PURE__ */ C("rect", { width: "780", height: "480", fill: "white" }),
        /* @__PURE__ */ C("path", { d: "M780 0H0V480H780V0Z", fill: "url(#paint0_radial_32822_58544)" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M780 0H694.609L694.762 26.9304C694.795 33.6208 685.58 39.0849 674.019 39.2202L369.177 42.9175C360.191 43.0259 352.67 46.3398 349.743 50.91C349.377 51.4812 349.083 52.072 348.867 52.6787C348.507 53.6898 348.363 54.7448 348.464 55.8262L355.63 132.911C355.926 136.102 358.276 138.912 361.854 140.975C366.774 143.811 374.015 145.237 381.432 144.306L780 94.2326V0Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M780 111.257L615.068 135.296C611.483 135.818 608.256 136.863 605.654 138.293C604.003 139.199 602.604 140.261 601.524 141.444C601.127 141.879 600.773 142.33 600.465 142.796L559.519 204.752C558.309 206.582 557.904 208.43 558.167 210.197C558.607 213.141 560.904 215.859 564.423 217.888C566.618 219.153 569.288 220.151 572.28 220.769C575.354 221.405 578.767 221.64 582.354 221.353L780 205.533V111.257Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M780 230.02L555.889 246.762C544.672 247.598 536.586 253.376 537.494 259.897L545.607 318.223C546.027 321.262 548.329 323.965 551.806 325.969C555.891 328.324 561.597 329.716 567.779 329.56L780 324.221V230.02Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M780 402.213L709.335 350.798L709.28 350.759C708.782 350.399 708.253 350.057 707.695 349.735C705.708 348.59 703.363 347.691 700.806 347.079C698.249 346.466 695.48 346.139 692.646 346.139L661.919 346.135C655.216 346.135 649.645 347.821 645.894 350.352C639.643 354.57 638.448 361.136 645.497 366.161L780 462.008V402.213Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M0 77.7485L100.702 68.9185C110.814 68.0334 118.379 63.101 118.696 57.1881L121.798 0H0V77.7485Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M14.9874 216.927L0 218.7V100.154C4.60026 100.549 8.74339 101.797 11.9093 103.622C15.3649 105.614 17.6555 108.295 18.1008 111.301L31.8369 203.869C32.7538 210.07 25.5221 215.679 14.9874 216.927Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M0 325.24L475.915 286.084C484.046 285.417 490.759 282.101 493.173 277.562L556.895 157.732L556.896 157.731C559.399 153.023 556.825 148.424 551.55 145.383C549.057 143.946 545.96 142.857 542.511 142.268C539.062 141.68 535.26 141.592 531.356 142.157L373.174 165.05C363.719 166.417 357.11 171.331 357.142 176.974L357.386 220.336C357.425 227.128 347.939 232.632 336.202 232.629L126.341 232.633C125.135 232.63 123.94 232.689 122.756 232.809L0 244.968V325.24Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M0 480H67.2497L97.8111 445.864C101.518 441.721 100.841 436.718 96.0646 432.941L2.83067 359.28C2.17071 358.759 1.44817 358.274 0.673897 357.827C0.453462 357.7 0.228761 357.576 0 357.455V480Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M163.955 16.8586L164.604 0H340.58L340.235 11.0524C340.042 17.3495 331.644 22.5247 320.797 23.0411L187.022 29.4278C184.921 29.5278 182.871 29.4481 180.914 29.2118C176.803 28.7154 173.108 27.5278 170.222 25.8645C166.749 23.862 164.451 21.1694 164.022 18.1644C163.961 17.7352 163.938 17.2995 163.955 16.8586Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M662.543 0H567.229L567.249 3.61115C567.268 7.01935 569.673 10.0844 573.519 12.3017C577.747 14.7388 583.715 16.1516 590.171 15.8699L643.052 13.5618C654.558 13.0577 663.24 7.33543 662.607 0.666611L662.543 0Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M374.342 0H534.476L534.532 9.83774C534.565 16.6264 525.08 22.1305 513.348 22.1306L395.721 22.1312C389.85 22.1312 384.528 20.7552 380.669 18.5306C376.81 16.306 374.415 13.2328 374.399 9.83852L374.342 0Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M513.459 314.204C513.054 311.116 510.735 308.408 507.261 306.405C502.31 303.55 495.013 302.13 487.574 303.091L287.104 328.972C275.917 330.419 268.758 336.744 270.926 343.262L287.605 393.281C288.454 395.828 290.564 398.002 293.453 399.668C299.666 403.25 309.479 404.474 318.078 401.972L504.69 347.665C512.36 345.433 516.935 340.75 516.285 335.793L513.459 314.204Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M177.979 480H257.245L267.03 436.341C267.266 435.275 267.261 434.2 267.017 433.142C266.87 432.506 266.638 431.877 266.32 431.259L220.45 341.867C219.407 339.829 217.52 338.052 215.066 336.637C210.409 333.952 203.705 332.569 196.826 333.173L78.9875 343.489C73.4945 343.971 68.9518 345.586 65.8006 347.813C60.549 351.523 59.1627 356.93 63.6855 361.612L177.979 480Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M765.078 480H288.096L305.469 443.976C307.187 440.415 310.75 437.867 315.683 436.667L559.912 361.993C563.859 361.04 568.538 360.979 573.543 361.831C573.543 361.831 684.487 429.437 765.078 480Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M97.9009 480H139.475L136.859 475.843C135.434 473.58 133.001 471.975 130.007 470.989C120.347 467.807 104.835 471.056 98.3904 479.369L97.9009 480Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M120.022 102.082L132.134 195.876C132.911 201.893 126.019 207.336 115.878 208.719L94.9014 211.574C89.2797 212.34 83.6999 211.739 79.1434 210.169C77.6245 209.646 76.2194 209.015 74.9643 208.292C73.896 207.676 72.9364 206.993 72.108 206.252C70.4016 204.725 69.2517 202.951 68.8543 201.011L49.6814 107.276C48.3592 100.828 55.9346 94.9155 66.9639 93.7693L95.002 90.8557C97.2899 90.618 99.5518 90.6014 101.725 90.7781C106.359 91.1543 110.592 92.4081 113.822 94.2704C116.436 95.7772 118.393 97.6826 119.375 99.8426C119.703 100.562 119.923 101.311 120.022 102.082Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M323.309 208.746C329.021 206.314 332.499 202.273 331.868 197.857L311.764 56.6799C311.471 54.6168 310.312 52.7145 308.515 51.0813C307.667 50.3115 306.678 49.6016 305.57 48.9628C301.233 46.4627 295.079 45.0521 288.507 45.4111L176.75 51.5327C172.758 51.7509 169.127 52.5965 166.123 53.8869C160.538 56.2865 157.124 60.225 157.604 64.53L173.116 202.661C173.467 205.773 175.792 208.548 179.343 210.595C183.438 212.955 189.161 214.35 195.37 214.185L311.731 211.108C316.083 210.993 320.058 210.13 323.309 208.746Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M530.238 373.96L383.295 432.82L312.109 146.305L372.697 122.036L530.238 373.96Z",
            fill: "url(#paint1_radial_32822_58544)"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M352.275 163.094C420.068 135.938 469.248 99.5013 462.122 81.7098C454.995 63.9183 394.26 71.5095 326.467 98.6652C258.674 125.821 209.494 162.258 216.621 180.049C223.747 197.841 284.482 190.25 352.275 163.094Z",
            fill: "#DDE6FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M396.669 98.2618C396.669 98.2618 373.871 118.137 341.173 131.235C308.475 144.333 278.26 145.693 278.26 145.693C265.162 112.995 281.051 75.8704 313.749 62.7727C346.447 49.6752 383.572 65.564 396.669 98.2618Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M304.704 78.9863C288.237 91.2426 285.185 114.144 289.436 133.049C289.86 134.799 288.733 136.588 286.938 136.875C285.186 137.172 283.53 135.902 283.359 134.135C283.094 131.486 282.785 128.851 282.57 126.21C281.896 112.991 284.441 99.1735 292.298 88.2698C295.401 83.9534 299.069 80.1211 303.688 77.2634C304.156 76.9739 304.771 77.1186 305.061 77.5869C305.364 78.0753 305.185 78.6985 304.704 78.9863Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M337.375 58.1943C355.469 58.1951 372.863 65.9722 384.969 79.5103C404.549 74.6382 421.812 72.0957 435.077 72.0957C449.742 72.0957 459.517 75.2041 462.123 81.7087C469.248 99.5005 420.069 135.937 352.276 163.093C309.28 180.316 269.126 189.668 243.683 189.668C229.009 189.668 219.227 186.556 216.621 180.049C211.532 167.345 235.162 145.136 273.767 123.585C273.12 97.7058 288.308 72.9634 313.749 62.772C321.507 59.6646 329.506 58.1941 337.375 58.1943ZM337.375 56.1943C329.026 56.1939 320.827 57.7825 313.005 60.9153C288.03 70.9202 271.575 95.5334 271.748 122.424C230.651 145.529 209.365 167.314 214.764 180.792C217.655 188.009 227.385 191.668 243.683 191.668C270.38 191.668 311.253 181.68 353.019 164.95C414.27 140.415 472.521 102.292 463.979 80.9651C461.09 73.7527 451.366 70.0957 435.077 70.0957C421.894 70.0957 404.823 72.5791 385.645 77.283C373.198 63.8667 355.675 56.1953 337.375 56.1943Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M431.306 87.3553C431.306 90.3659 428.866 92.8064 425.855 92.8064C422.845 92.8064 420.404 90.3659 420.404 87.3553C420.404 84.3448 422.845 81.9043 425.855 81.9043C428.866 81.9043 431.306 84.3448 431.306 87.3553Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M393.131 124.54C396.141 124.54 398.582 122.1 398.582 119.089C398.582 116.079 396.141 113.638 393.131 113.638C390.12 113.638 387.68 116.079 387.68 119.089C387.68 122.1 390.12 124.54 393.131 124.54Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M347.734 150.387C350.745 150.387 353.185 147.947 353.185 144.936C353.185 141.926 350.745 139.485 347.734 139.485C344.724 139.485 342.283 141.926 342.283 144.936C342.283 147.947 344.724 150.387 347.734 150.387Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M294.637 166.161C297.647 166.161 300.088 163.721 300.088 160.71C300.088 157.7 297.647 155.259 294.637 155.259C291.626 155.259 289.186 157.7 289.186 160.71C289.186 163.721 291.626 166.161 294.637 166.161Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M249.14 164.466C249.14 167.477 246.7 169.917 243.689 169.917C240.679 169.917 238.238 167.477 238.238 164.466C238.238 161.456 240.679 159.015 243.689 159.015C246.7 159.015 249.14 161.456 249.14 164.466Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M423.961 364.406C461.494 364.406 491.921 354.018 491.921 341.203C491.921 328.388 461.494 318 423.961 318C386.428 318 356.002 328.388 356.002 341.203C356.002 354.018 386.428 364.406 423.961 364.406Z",
            fill: "url(#paint2_radial_32822_58544)"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M425.857 345.043L384.645 337.363L374.182 307.716L415.392 315.395L425.857 345.043Z",
            fill: "#DDE6FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M415.393 315.395L442.655 283.549L401.445 275.875L374.182 307.716L415.393 315.395Z",
            fill: "#DDE6FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M415.393 315.395L423.324 283.321L382.114 275.646L374.182 307.716L415.393 315.395Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M423.324 283.325L442.654 283.549L401.443 275.875L382.113 275.646L423.324 283.325Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M423.324 283.321L442.655 283.549L453.119 313.195L425.857 345.043L415.393 315.395L423.324 283.321Z",
            fill: "#DDE6FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M608.958 279.871C608.958 278.821 608.107 277.97 607.057 277.97C606.007 277.97 605.156 278.821 605.156 279.871V298.471C605.156 299.52 606.007 300.372 607.057 300.372C608.107 300.372 608.958 299.52 608.958 298.471V279.871Z",
            fill: "#EAE6DF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M623.874 272.342C624.606 263.243 617.823 255.273 608.723 254.54C599.624 253.808 591.653 260.591 590.921 269.691C590.189 278.791 596.972 286.761 606.072 287.493C615.172 288.225 623.142 281.442 623.874 272.342Z",
            fill: "#F2F0E9"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M512.332 98.2102C512.332 97.3967 511.673 96.7373 510.86 96.7373C510.046 96.7373 509.387 97.3967 509.387 98.2102V112.623C509.387 113.436 510.046 114.095 510.86 114.095C511.673 114.095 512.332 113.436 512.332 112.623V98.2102Z",
            fill: "#EAE6DF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M496.559 98.259C496.559 102.21 502.961 105.415 510.86 105.415C518.76 105.415 525.159 102.21 525.159 98.259C525.159 94.308 510.86 68.21 510.86 68.21C510.86 68.21 496.559 94.3053 496.559 98.259Z",
            fill: "#F2F0E9"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M629.371 192.861L648.873 181.478V158.357L629.371 169.74V192.861Z",
            fill: "#F2F0E9"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M629.37 192.861L609.869 181.478V158.357L629.37 169.74V192.861Z",
            fill: "#F2F0E9"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M629.37 169.74L609.869 158.358L629.37 146.976L648.872 158.358L629.37 169.74Z",
            fill: "#FCFAF5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M134.101 290.83L97.7949 269.871V212.653L134.101 233.61V290.83Z",
            fill: "#F2F0E9"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M134.101 233.61L170.408 212.653L134.101 191.701L97.7949 212.653L134.101 233.61Z",
            fill: "#F1F1F6"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M134.101 233.61L152.254 206.004L115.949 185.051L97.7949 212.652L134.101 233.61Z",
            fill: "#FCFAF5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M152.255 206.008L170.408 212.652L134.101 191.701L115.949 185.051L152.255 206.008Z",
            fill: "#FCFAF5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M152.255 206.004L170.409 212.652V269.87L134.102 290.828V233.609L152.255 206.004Z",
            fill: "#F2F0E9"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M187.903 347.445C187.903 346.395 187.052 345.544 186.002 345.544C184.953 345.544 184.102 346.395 184.102 347.445V366.045C184.102 367.095 184.953 367.946 186.002 367.946C187.052 367.946 187.903 367.095 187.903 366.045V347.445Z",
            fill: "#EAE6DF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M202.819 339.917C203.551 330.817 196.768 322.847 187.668 322.115C178.569 321.382 170.599 328.166 169.867 337.265C169.134 346.365 175.918 354.335 185.017 355.067C194.117 355.799 202.087 349.016 202.819 339.917Z",
            fill: "#F2F0E9"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M414.349 235.727C414.282 235.847 414.213 235.966 414.139 236.08L414.143 236.083C412.427 238.905 410.056 241.279 407.42 243.251C406.474 243.964 405.479 244.611 404.466 245.226L404.463 245.226C403.798 245.628 403.123 246.012 402.433 246.376L402.431 246.376C400.992 247.137 399.529 247.814 398.02 248.427C392.505 250.689 385.511 252.372 379.753 252.951C379.713 252.898 378.952 250.449 378.72 249.534C378.398 248.319 378.097 247.079 377.831 245.85C377.083 242.394 376.572 238.875 376.376 235.343C376.35 234.924 376.337 234.502 376.321 234.082C376.133 227.677 377.014 220.961 380.431 215.418C386.055 206.125 398.558 203.179 407.712 208.988C416.755 214.526 419.752 226.575 414.349 235.727Z",
            fill: "#A1C0FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M393.737 231.576C396.812 233.559 400.913 232.673 402.896 229.596C404.879 226.52 403.994 222.42 400.916 220.436C397.841 218.453 393.74 219.341 391.757 222.416C389.774 225.492 390.661 229.593 393.737 231.576Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: [
        /* @__PURE__ */ l(
          "radialGradient",
          {
            id: "paint0_radial_32822_58544",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(389.999 239.968) scale(384.968 243.219)",
            children: [
              /* @__PURE__ */ C("stop", { stopColor: "#F8F6EF" }),
              /* @__PURE__ */ C("stop", { offset: "0.55192", stopColor: "#F9F7F1" }),
              /* @__PURE__ */ C("stop", { offset: "0.88344", stopColor: "#FCFCF9" }),
              /* @__PURE__ */ C("stop", { offset: "1", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ l(
          "radialGradient",
          {
            id: "paint1_radial_32822_58544",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(362.042 183.384) scale(231.531 231.531)",
            children: [
              /* @__PURE__ */ C("stop", { stopColor: "#DDE6FF", stopOpacity: "0.7" }),
              /* @__PURE__ */ C("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
            ]
          }
        ),
        /* @__PURE__ */ l(
          "radialGradient",
          {
            id: "paint2_radial_32822_58544",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(423.961 341.204) scale(50.0371 16.0761)",
            children: [
              /* @__PURE__ */ C("stop", { stopColor: "#A1C0FF", stopOpacity: "0.8" }),
              /* @__PURE__ */ C("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
            ]
          }
        ),
        /* @__PURE__ */ C("clipPath", { id: "clip0_32822_58544", children: /* @__PURE__ */ C("rect", { width: "780", height: "480", fill: "white" }) })
      ] })
    ]
  }
);
export {
  d as UnexpectedErrorIllustration
};
//# sourceMappingURL=index.es479.js.map
